import { recoverUserReplyTemplatePublic } from '../../services';
import { showAlert } from '../../slices/alertSlice';
import { createAppAsyncThunk } from '../../store/createAppAsyncThunk';
import { EAlert } from '../../types/alert';

import type {
  IRecoverUserReplyTemplateRequest,
  ICreateUserReplyTemplatesListResponse,
} from '../../types/replyTemplates';

export const recoverUserReplyTemplateThunk = createAppAsyncThunk<
  ICreateUserReplyTemplatesListResponse,
  IRecoverUserReplyTemplateRequest,
  { rejectValue: string }
>('chats/recoverUserReplyTemplateThunk', async (parameters: IRecoverUserReplyTemplateRequest, _thunkApi) => {
  const { fulfillWithValue, rejectWithValue, extra: context, dispatch } = _thunkApi;

  try {
    const response = await recoverUserReplyTemplatePublic(context, parameters);

    dispatch(showAlert({ message: 'Шаблон восстановлен', type: EAlert.Info }));

    return fulfillWithValue(response);
  } catch (e) {
    dispatch(showAlert({ message: 'Не удалось восстановить шаблон' }));

    return rejectWithValue(e instanceof Error ? e.message : String(e));
  }
});
